import { useTranslation } from "next-i18next";
import Image from "next/image";

const ImportanceOfCloudTech = () => {
    const { t } = useTranslation(["common", "cloudServer"]);

    return (
        <div className="container py-12 mx-auto lg:py-24">
            <div className="grid pt-8 mt-12 mb-12 rounded-2xl lg:pt-4 lg:mb-32 lg:gap-10 lg:p-8 lg:grid-cols-2 lg:mt-24 lg:container lg:mx-auto bg-makdosDarkPurple">
                <div className="p-4 px-8 pt-1 space-y-8 lg:p-8">
                    <div className="space-y-3">
                        <h2 className="text-3xl font-semibold text-white lg:text-4xl">{t("cloudServer:importanceOfCloudTech")}</h2>
                        <div className="text-sm text-white" dangerouslySetInnerHTML={{ __html: t("cloudServer:importanceOfCloudTechDesc") }}></div>
                    </div>

                    <div className="space-y-8">
                        <div className="space-y-4">
                            <div className="flex space-x-2 font-medium text-white">
                                <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                                <p> {t("cloudServer:importanceOfCloudTechDesc2")}</p>
                            </div>
                            <div className="flex space-x-2 font-medium text-white ">
                                <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                                <p> {t("cloudServer:importanceOfCloudTechDesc3")}</p>
                            </div>
                            <div className="flex space-x-2 font-medium text-white ">
                                <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                                <p> {t("cloudServer:importanceOfCloudTechDesc4")}</p>
                            </div>
                            <div className="flex space-x-2 font-medium text-white ">
                                <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                                <p> {t("cloudServer:importanceOfCloudTechDesc5")}</p>
                            </div>
                            <div className="flex space-x-2 font-medium text-white ">
                                <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                                <p> {t("cloudServer:importanceOfCloudTechDesc6")}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="m-8 lg:relative">
                    <div className="p-4 bg-white border-4 rounded-md -top-32 lg:border-8 lg:absolute lg:-right-16 lg:p-8 border-makdosYellow">
                        <div className="flex justify-center mb-8">
                            <Image src={"/whyCloudServer.png"} width={264} height={150} alt={t("cloudServer:whyWithMakdosCloudRental")} title={t("cloudServer:whyWithMakdosCloudRental")} />
                        </div>
                        <h2 className="pb-4 text-3xl font-semibold lg:text-4xl text-titleColor">{t("cloudServer:whyWithMakdosCloudRental")}</h2>

                        <div className="pb-3 space-x-2 flexCenter">
                            <p class="flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full"><i className="ri-check-line" /></p>
                            <div className="lg:text-lg" dangerouslySetInnerHTML={{ __html: t("cloudServer:whyWithMakdosCloudRentalDesc") }}></div>
                        </div>

                        <div className="pb-3 space-x-2 flexCenter">
                            <div class="flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full"><i className="ri-check-line" /></div>
                            <div className="lg:text-lg" dangerouslySetInnerHTML={{ __html: t("cloudServer:whyWithMakdosCloudRentalDesc2") }}></div>
                        </div>

                        <p className="pb-3 space-x-2 flexCenter">
                            <span class="flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full"><i className="ri-check-line" /></span>
                            <span className="lg:text-lg">{t("cloudServer:whyWithMakdosCloudRentalDesc3")}</span>
                        </p>

                        <div className="pb-3 space-x-2 flexCenter">
                            <div class="flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full"><i className="ri-check-line" /></div>
                            <div className="lg:text-lg" dangerouslySetInnerHTML={{ __html: t("cloudServer:whyWithMakdosCloudRentalDesc4") }}></div>
                        </div>

                        <div className="space-x-2 ">
                            🚀 <div className="lg:text-lg" dangerouslySetInnerHTML={{ __html: t("cloudServer:whyWithMakdosCloudRentalDesc5") }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImportanceOfCloudTech